import React, { useState } from "react";
import Modal from "~/shared/ui/Fields/Modal";
import s from "../PhotoGallery.less";
import Preloader from "~/components/Preloader";
import clsx from "clsx";

interface IPhotoModalProps {
  isOpen: boolean;
  imageLink: string;
  description?: string;
  withoutMargin?;
  title?;
  onClose: () => void;
}

const PhotoModal: React.FC<IPhotoModalProps> = ({
  isOpen,
  imageLink,
  description,
  onClose,
  title,
  withoutMargin = false,
}) => {
  const [imgLoad, setImgLoad] = useState(false);
  const ingLoadHandle = () => setImgLoad(true);

  return (
    <Modal
      isOpen={isOpen}
      actionClose={onClose}
      customClassName={s.modal}
      withoutMargin={withoutMargin}
    >
      <div className={s.modalImg}>
        {!imgLoad && (
          <div className={s.preloader}>
            <Preloader />
          </div>
        )}
        {imageLink && (
          <>
            <img
              className={clsx(s.image, {
                [s.unloadImg]: !imgLoad,
              })}
              src={imageLink}
              onLoad={ingLoadHandle}
              alt="Selected"
            />
            <div className={s.subtitle}>
              [{title}] {description}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default PhotoModal;
